import React from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';

// A slim progress bar fixed to the very top of the viewport that fills up
// as the visitor scrolls down the page.
const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 25,
    restDelta: 0.001,
  });

  return (
    <motion.div
      style={{ scaleX }}
      className="fixed top-0 left-0 right-0 h-1 origin-left bg-accent-green z-[60]"
      aria-hidden="true"
    />
  );
};

export default ScrollProgress;
